/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : VlcIndex.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * duplicate of labcars
 */

import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Breadcrumbs,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import setSelectedProject from "../../../redux/actions/selectProject";
import CommonBreadcrumbs from "../common/Breadcrumbs/CommonBreadcrumbs";
import ProjectVarientAccordian from "./ProjectVarientAccordian/ProjectVarientAccordian";
import {
  HandleApiActions,
  labCar,
  profileActions,
  userManagementApis,
} from "../../../redux/actions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import VlcMain from "./pages/VlcMain";
import VlcCarPage from "./pages/VlcCarPage";
import VlcCarCard from "../../../pages/labcar/CarCard";
import VlcVehicleSystemsIndex from "./VlcVehicleSystemsIndex";
import ProjectVariantSearchbar from "../common/projectSearchbar/ProjectvariantSearchbar";
import CustomFilterV2 from "../common/filter/CustomFilterV2";
import CustomRadioButtonV2 from "../common/radioButton/CustomRadioButtonV2";
import CustomCheckBoxV2 from "../common/checkBox/CustomCheckBoxV2";
import { filter } from "d3";
import ProjectVariantDialog from "./ProjectVarientAccordian/ProjectVariantDialog";
import EELinkPage from "./pages/EELinkPage";
import LinkHomePage from "./pages/LinkHomePage";

import sortUp from "../../../assets/sortup.png";
import sortDown from "../../../assets/sortdown.png";
import { use } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";

function VlcIndex({ drawerWidth = 240, drawerOpen = true }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const updatedSelectedProjectId = queryParams.get("project_id");
  const selectedZoneFromUrl = queryParams.get("selectedZone");
  const zonePositionFromUrl = queryParams.get("zonePosition");

  const dispatch = useDispatch();

  /* useSelectors */

  const selectedProject = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  const selectedVariant = useSelector(
    (state) => state.projectConfigReducer.selectedVariantDetails,
  );

  const { eeComponentsList } = useSelector(
    (state) => state.labCarReducer,
    shallowEqual,
  );

  const variants = useSelector((state) => state.projectConfigReducer.variants);

  const variantDetails = useSelector((state) => state.variantReducer);

  const settingsVehicleSystemsDetails = useSelector(
    (state) => state.vehicleSystemsReducer,
  );

  const profileDetails = useSelector((store) => store.profileReducer);

  const roleType = profileDetails?.profile?.role_details?.role_type;

  const supplier = roleType === 2;

  /* Project-related state variables */
  const [projectOptionsList, setProjectOptionsList] = useState([]);
  const [variantOptionList, setVariantOptionsList] = useState([]);
  // const [selectedProject, setSelectedProject] = useState(null);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState(null);
  const [selectedVariantDetails, setSelectedVariantDetails] = useState(null);
  const [selectedSingleVariantDetails, setSelectedSingleVariantDetails] =
    useState([]);
  const [selectedVehicleView, setSelectedVehicleView] = useState("ECU");

  const [availableZones, setAvailableZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState(null);
  const [zoneEECountList, setZoneEECountList] = useState([]);
  const [zoneVSCountList, setZoneVSCountList] = useState([]);
  const [centralizedEEList, setCentralizedEEList] = useState([]);
  const [selectedEEComponentDetails, setSelectedEEComponentDetails] =
    useState(null);
  const [vsAndVCOptionsList, setVSAndVCOptionsList] = useState([]);
  const [availableZonesSupplier, setAvailableZonesSupplier] = useState([]);
  const [selectedZoneDetails, setSelectedZoneDetails] = useState(null);
  const [zoneEEList, setZoneEEList] = useState([]);
  const [projectEECount, setProjectEECount] = useState(0);
  const [anchorVlcFilter, setAnchorVlcFilter] = useState(null);
  const [openVlcFilter, setOpenVlcFilter] = useState(false);
  const [getApiDataforFilter, setGetApiDataforFilter] = useState(false);
  const appliedUrlZoneKeyRef = useRef(null);
  const [filterData, setFilterData] = useState({
    sortBy: "created_at",
    sortOrder: "ASC",
    component: "EE",
    componentTypeAll: true,
    componentTypeDraft: true,
    componentTypeActionRequired: true,
    componentTypeGithub: true,
  });

  const [openRecreateDialog, setOpenRecreateDialog] = useState(false);

  // const [selectedVariant, setSelectedVariant] = useState(null);

  // functions

  const handleHsFilterIconClose = (action) => {
    setAnchorVlcFilter(null);
    setOpenVlcFilter(false);
  };

  const handleFliterClick = () => {
    setGetApiDataforFilter(!getApiDataforFilter);
  };

  const handleVlcFilterButton = (action) => {
    switch (action) {
      case "cancel":
        handleHsFilterIconClose();
        break; // prevents fall-through
      case "apply":
        handleFliterClick();
        handleHsFilterIconClose();
        break;
      default:
        break;
    }
  };

  // inside your component
  const handleFilterCheckboxChange = (name) => {
    let updated = { ...filterData, [name]: !filterData[name] };

    // If ALL checkbox was clicked
    if (name === "componentTypeAll") {
      const newValue = !filterData.componentTypeAll;
      updated = {
        componentTypeAll: newValue,
        componentTypeDraft: newValue,
        componentTypeActionRequired: newValue,
        componentTypeGithub: newValue,
      };
    } else {
      // If any individual checkbox is clicked
      const {
        componentTypeDraft,
        componentTypeActionRequired,
        componentTypeGithub,
      } = updated;

      // If ALL three are selected → ALL = true
      if (
        componentTypeDraft &&
        componentTypeActionRequired &&
        componentTypeGithub
      ) {
        updated.componentTypeAll = true;
      } else {
        updated.componentTypeAll = false;
      }
    }

    setFilterData({
      ...filterData,
      ...updated,
    });
  };

  useEffect(() => {
    // Switch car card count mode based on route
    // vehicle-systems -> VEHICLE (show VS counts), EESWM -> ECU (show EE counts)
    if (location?.pathname?.includes("vehicle-systems")) {
      setSelectedVehicleView("VEHICLE");
    } else if (location?.pathname?.includes("EESWM")) {
      setSelectedVehicleView("ECU");
    }
  }, [location?.pathname]);

  // Ensure zone highlight is preserved when navigating back to EE Architecture
  // Run only on route transitions, not on zone changes, to avoid oscillation
  useEffect(() => {
    const goingToEE = location?.pathname?.includes("EESWM");
    if (!goingToEE) return;
    if (!selectedProjectDetails?.is_zonal) return;
    if (selectedZoneFromUrl || zonePositionFromUrl) return;

    const currentName = selectedZone?.zone_position_name?.trim();
    const defaultZoneName = availableZones?.[0]?.position_name?.trim();

    // If no zone selected, set to first available zone
    if (!currentName && defaultZoneName) {
      setSelectedZone({ zone_position_name: defaultZoneName });
    }
    // If a zone is already selected, leave it as-is; user interactions take precedence
  }, [
    location?.pathname,
    selectedProjectDetails?.is_zonal,
    availableZones,
    selectedZoneFromUrl,
    zonePositionFromUrl,
  ]);

  useEffect(() => {
    const goingToEE = location?.pathname?.includes("EESWM");
    if (!goingToEE || !selectedProjectDetails?.is_zonal) return;
    if (!selectedZoneFromUrl && !zonePositionFromUrl) return;
    const urlZoneKey = `${selectedZoneFromUrl || ""}|${zonePositionFromUrl || ""
      }`;
    if (appliedUrlZoneKeyRef.current === urlZoneKey) return;

    const matchedZone = selectedProjectDetails?.project_zones?.find((zone) => {
      return (
        zone?.zone_name === selectedZoneFromUrl ||
        String(zone?.position) === String(selectedZoneFromUrl) ||
        String(zone?.position) === String(zonePositionFromUrl)
      );
    });
    const zoneName = matchedZone?.zone_name || selectedZoneFromUrl;

    if (zoneName && selectedZone?.zone_position_name !== zoneName) {
      setSelectedZone({ zone_position_name: zoneName });
    }
    appliedUrlZoneKeyRef.current = urlZoneKey;
  }, [
    location?.pathname,
    selectedProjectDetails?.is_zonal,
    selectedProjectDetails?.project_zones,
    selectedZoneFromUrl,
    zonePositionFromUrl,
    selectedZone?.zone_position_name,
  ]);

  // Fallback: if counts arrive but no zone is selected, assert the first zone.
  // This covers route switches where availableZones were already loaded
  // and the prior effect did not run at the right time.
  useEffect(() => {
    const goingToEE = location?.pathname?.includes("EESWM");
    if (!goingToEE) return;
    if (!selectedProjectDetails?.is_zonal) return;
    if (selectedZoneFromUrl || zonePositionFromUrl) return;
    if (selectedZone?.zone_position_name) return;
    const firstZoneName = availableZones?.[0]?.position_name;
    if (firstZoneName) {
      setSelectedZone({ zone_position_name: firstZoneName });
    }
  }, [
    zoneEECountList,
    location?.pathname,
    availableZones,
    selectedProjectDetails?.is_zonal,
    selectedZoneFromUrl,
    zonePositionFromUrl,
    selectedZone?.zone_position_name,
  ]);

  useEffect(() => {
    const filteredVariantOptionsList = variants.map((el) => ({
      value: el.variant_id,
      label: el.name,
      color: el.color_code,
    }));
    setVariantOptionsList(filteredVariantOptionsList);
  }, [variants]);

  /* State for handling no projects found message */
  const [showNoProjectsFound, setShowNoProjectsFound] = useState(false);

  /* useEffects */
  useEffect(() => {
    // Get the project details
    dispatch(HandleApiActions({ ...labCar.get_project_details }));
    // Get the roles list
    dispatch(
      HandleApiActions({
        ...userManagementApis.get_roles_list,
        params: {
          page_number: 1,
          page_size: 100,
          sort_column: "created_at",
          sort_order: "ASC",
        },
        show_toast: false,
      }),
    );
    // Get the profile details
    dispatch(HandleApiActions({ ...profileActions.get_profile_details }));
  }, [dispatch]);

  // Car image

  const getZoneEECountList = useCallback(
    async (projectId, variantId) => {
      const resp = await dispatch(
        HandleApiActions({
          ...labCar.get_ee_components_count,
          params: {
            project_id: projectId,
            variant_id: variantId,
            page_number: 1,
            page_size: 10000,
          },
          show_toast: false,
        }),
      );
      if (!resp.error) {
        if (resp?.data?.length > 0) {
          // Set the project total ee count
          setProjectEECount(resp?.data?.length || 0);

          const components = resp?.data;
          const counts = components?.reduce((acc, component) => {
            const position = component?.zone_details?.position;
            if (!acc[position]) {
              acc[position] = 0;
            }
            acc[position]++;
            return acc;
          }, {});

          const filteredZoneEECountList = Object?.entries(counts)?.map(
            ([zone_position, ee_components_count]) => ({
              zone_position,
              ee_components_count,
            }),
          );
          if (filteredZoneEECountList?.length > 0) {
            setZoneEECountList(filteredZoneEECountList);
          }
        }
      }
    },
    [dispatch],
  );
  const getZoneVSCountList = useCallback(async () => {
    const apiDetails = labCar.get_vehicle_systems_all;
    const resp = await dispatch(
      HandleApiActions({
        ...apiDetails,
        show_toast: false,
        params: {
          project_id: Number(selectedProjectDetails?.project_id),
          variant_id: Number(selectedSingleVariantDetails?.variant_id),
          page_number: 1,
          page_size: 10000,
        },
      }),
    );
    if (!resp.error) {
      if (resp?.data?.length > 0) {
        const components = resp?.data;
        const counts = components?.reduce((acc, component) => {
          const position = component?.zone_details?.[0]?.position;
          if (!acc[position]) {
            acc[position] = 0;
          }
          acc[position]++;
          return acc;
        }, {});

        const filteredZoneVSCountList = Object?.entries(counts)?.map(
          ([zone_position, vehicle_systems_count]) => ({
            zone_position,
            vehicle_systems_count,
          }),
        );
        if (filteredZoneVSCountList?.length > 0) {
          setZoneVSCountList(filteredZoneVSCountList);
        }
      }
    }
  }, [
    dispatch,
    selectedProjectDetails?.project_id,
    selectedSingleVariantDetails?.variant_id,
  ]);
  useEffect(() => {
    if (selectedProjectDetails?.project_id !== selectedProject?.project_id) {
      setAvailableZones([]);
      setAvailableZonesSupplier([]);
      setSelectedZone(null);
      setSelectedZoneDetails(null);
      setZoneEEList([]);
      setCentralizedEEList([]);
      setZoneEECountList([]);
      setZoneVSCountList([]);
      setProjectEECount(0);
      setSelectedSingleVariantDetails([]);
      // debugger
      // Reset the last counts fetch pair so a previously fetched
      // (project, variant) will refetch after selecting a project
      // without variants and coming back to the same selection.
      if (lastCountsFetchRef && lastCountsFetchRef.current) {
        lastCountsFetchRef.current = { projectId: null, variantId: null };
      }
    }
  }, [selectedProject]);

  useEffect(() => {
  }, [selectedSingleVariantDetails]);
  const lastCountsFetchRef = useRef({ projectId: null, variantId: null });
  useEffect(() => {
    const projectId = selectedProjectDetails?.project_id;
    const variantId = selectedSingleVariantDetails?.variant_id;
    if (!projectId || !variantId) return;
    // Guard: ensure the selected variant belongs to the current project to avoid stale fetches
    const variantProjectId = selectedSingleVariantDetails?.project_id;
    if (variantProjectId && Number(variantProjectId) !== Number(projectId)) {
      return;
    }

    const { projectId: prevPid, variantId: prevVid } =
      lastCountsFetchRef.current;
    if (prevPid === projectId && prevVid === variantId) return;

    lastCountsFetchRef.current = { projectId, variantId };
    getZoneEECountList(projectId, variantId);
    getZoneVSCountList();
  }, [
    selectedProjectDetails?.project_id,
    selectedSingleVariantDetails?.variant_id,
    getZoneEECountList,
    getZoneVSCountList,
  ]);

  useEffect(() => {
    // Update EE components list only when a valid variant is selected for the current project
    // Prevents copying stale data into local state when switching to a project with no variants
    if (!selectedProjectDetails) return;
    const projectId = selectedProjectDetails?.project_id;
    const variantId = selectedSingleVariantDetails?.variant_id;
    const variantProjectId = selectedSingleVariantDetails?.project_id;

    const hasVariant = Boolean(variantId);
    const isVariantForProject =
      projectId && variantProjectId
        ? Number(projectId) === Number(variantProjectId)
        : true;

    if (!hasVariant || !isVariantForProject) {
      setZoneEEList([]);
      setCentralizedEEList([]);
      return;
    }

    if (eeComponentsList) {
      if (selectedProjectDetails.is_zonal) {
        setZoneEEList(eeComponentsList);
      } else {
        setCentralizedEEList(eeComponentsList);
      }
    }
  }, [
    eeComponentsList,
    selectedProjectDetails,
    selectedSingleVariantDetails?.variant_id,
  ]);

  useEffect(() => {
    setSelectedProjectDetails(selectedProject);
  }, [selectedProject]);

  useEffect(() => {
    const projectId =
      selectedProjectDetails?.project_id || selectedProject?.project_id;
    const variantId = selectedVariant?.variant_id;
    const variantProjectId = selectedVariant?.project_id;
    const hasVariants = Array.isArray(variants) && variants.length > 0;

    // If the selected project has no variants, or the redux-selected variant is for a different project,
    // clear local selected variant so the UI doesn't keep showing the last project's data.
    if (!projectId || !hasVariants || !variantId) {
      setSelectedSingleVariantDetails([]);
      return;
    }

    if (variantProjectId && Number(variantProjectId) !== Number(projectId)) {
      setSelectedSingleVariantDetails([]);
      return;
    }

    setSelectedSingleVariantDetails(selectedVariant);
    // debugger;
  }, [
    selectedVariant,
    selectedProjectDetails?.project_id,
    selectedProject?.project_id,
    variants,
  ]);

  useEffect(() => {
    /* Zones */
    if (selectedProjectDetails && selectedProjectDetails?.is_zonal) {

      let filteredAvailableZones = selectedProjectDetails?.project_zones?.map(
        (el) => {
          return {
            zone_position: el.position,
            position_name: el.zone_name,
          };
        },
      );
      setAvailableZones(filteredAvailableZones);
    }
  }, [selectedProjectDetails]);

  useEffect(() => {
    /* Update selected zone details based on the selected zone */
    if (
      selectedZone &&
      selectedZone?.zone_position_name &&
      selectedProjectDetails &&
      selectedProjectDetails?.project_zones
    ) {
      let filteredSelectedZoneDetails =
        selectedProjectDetails?.project_zones?.find(
          (el) => el?.zone_name === selectedZone?.zone_position_name,
        );
      setSelectedZoneDetails(filteredSelectedZoneDetails);
    }
  }, [selectedZone, selectedProjectDetails]);

  useEffect(() => {
    let filteredVehicleSystemOptionsList = Array.isArray(
      settingsVehicleSystemsDetails?.vehicleSystemsDetails?.data,
    )
      ? settingsVehicleSystemsDetails.vehicleSystemsDetails.data.map((vs) => ({
        value: vs?.name,
        label: vs?.name,
        vehicleComponentsOptionsList: Array.isArray(vs?.components)
          ? vs.components.map((vc) => ({
            value: vc,
            label: vc,
          }))
          : [],
      }))
      : [];

    setVSAndVCOptionsList(filteredVehicleSystemOptionsList);
  }, [settingsVehicleSystemsDetails]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
        // bgcolor: "#f9f9f9",
        // bgcolor: "red",
      }}
    >
      {/* 🔹 Breadcrumb area */}
      <Box sx={{ p: 1, flexShrink: 0 }}>
        <CommonBreadcrumbs
          items={[
            { label: "Virtual Lab-Car" },
            location?.pathname?.includes("EESWM")
              ? { label: "EE Architecture" }
              : { label: "Vehicle Systems" },
          ]}
        />
      </Box>

      {/* 🔹 Main content area */}
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          gap: 1.5,
          ml: 1,
          mb: 1,
          alignItems: "center",
        }}
      >
        {/* <Box>
          <CustomFilterV2
            anchorEl={anchorVlcFilter}
            open={openVlcFilter}
            widthPerColumn={"160px"}
            handleClick={(event) => {
              setAnchorVlcFilter(event.currentTarget);
              setOpenVlcFilter(true);
            }}
            handleFilterButton={handleVlcFilterButton}
            handleClose={handleHsFilterIconClose}
            sections={[
              {
                heading: "Sorting",
                content: (
                  <Box
                    sx={{
                      // pl: 2,
                      display: "flex",
                      flexDirection: "column",
                      // gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        pl: 3,
                        pb: 1.5,
                        display: "flex",
                        gap: 6,
                      }}
                    >
                      <CustomRadioButtonV2
                        spacing={3}
                        value={filterData?.sortBy}
                        onChange={(e) => {
                          setFilterData({
                            ...filterData,
                            sortBy: e.target.value,
                          });
                        }}
                        data={[
                          { value: "created_at", label: "Created at" },
                          { value: "updated_at", label: "Updated at" },
                        ]}
                      />
                    </Box>
                    // Sort order (selected = green bg, white icon/text)
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                        flexDirection: "column",
                      }}
                    >
                      <Box
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                          setFilterData({ ...filterData, sortOrder: "ASC" })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            setFilterData({
                              ...filterData,
                              sortOrder: "ASC",
                            });
                          }
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          cursor: "pointer",
                          px: 1.5,
                          py: 0.75,
                          width: "100%",
                          borderRadius: 0,
                          backgroundColor:
                            filterData?.sortOrder === "ASC"
                              ? "#26890D"
                              : "transparent",
                          color:
                            filterData?.sortOrder === "ASC"
                              ? "#FFFFFF"
                              : "#000000",
                        }}
                      >
                        <img
                          src={sortUp}
                          alt="Sort Asc–Des"
                          style={{
                            width: 16,
                            height: 16,
                          }}
                        />
                        <Typography variant="body2" sx={{ color: "inherit" }}>
                          Sort Asc –Des
                        </Typography>
                      </Box>

                      <Box
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                          setFilterData({
                            ...filterData,
                            sortOrder: "DESC",
                          })
                        }
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            setFilterData({
                              ...filterData,
                              sortOrder: "DESC",
                            });
                          }
                        }}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          cursor: "pointer",
                          px: 1.5,
                          py: 0.75,
                          borderRadius: 0,
                          width: "100%",
                          backgroundColor:
                            filterData?.sortOrder === "DESC"
                              ? "#26890D"
                              : "transparent",
                          color:
                            filterData?.sortOrder === "DESC"
                              ? "#FFFFFF"
                              : "#000000",
                        }}
                      >
                        <img
                          src={sortDown}
                          alt="Sort Des–Asc"
                          style={{
                            width: 16,
                            height: 16,
                          }}
                        />
                        <Typography variant="body2" sx={{ color: "inherit" }}>
                          Sort Des-Asc
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ),
              },
              {
                heading: "Filter",
                content: (
                  <Box>
                    <Box sx={{ pl: 1.3, pb: 1 }}>
                      <CustomRadioButtonV2
                        value={filterData?.component}
                        onChange={(e) => {
                          setFilterData({
                            ...filterData,
                            component: e.target.value,
                          });
                        }}
                        data={[
                          { value: "EE", label: "EE Component" },
                          { value: "SWM", label: "Software Module" },
                        ]}
                      />
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <CustomCheckBoxV2
                        value={filterData.componentTypeAll}
                        onChange={() =>
                          handleFilterCheckboxChange("componentTypeAll")
                        }
                        label="All"
                      />

                      <CustomCheckBoxV2
                        value={filterData.componentTypeDraft}
                        onChange={() =>
                          handleFilterCheckboxChange("componentTypeDraft")
                        }
                        label="Draft"
                      />

                      <CustomCheckBoxV2
                        value={filterData.componentTypeActionRequired}
                        onChange={() =>
                          handleFilterCheckboxChange(
                            "componentTypeActionRequired"
                          )
                        }
                        label="Action Required"
                      />

                      <CustomCheckBoxV2
                        value={filterData.componentTypeGithub}
                        onChange={() =>
                          handleFilterCheckboxChange("componentTypeGithub")
                        }
                        label="Github"
                      />
                    </Box>
                  </Box>
                ),
              },
            ]}
          />
        </Box> */}

        <Box>
          <ProjectVariantSearchbar />
        </Box>
        <Box>
          <ProjectVariantDialog />
        </Box>
      </Box>

      {/* 🔹 Cards Container - Single Scrollable Area */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
          display: "flex",
          gap: 1,
          px: 1,
          py: 1,
          boxSizing: "border-box",
        }}
      >
        {/* 🟦 Left Box (CarCard) */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            width: "auto",
            maxWidth: { xs: "100%", md: "420px" },
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
          }}
        >
          {supplier ? (
            // For suppliers: only show if is_zonal is true
            selectedProjectDetails?.is_zonal && (
              <>
                <VlcCarCard
                  availableZones={availableZones}
                  selectedComponent={selectedZone}
                  setSelectedComponent={setSelectedZone}
                  zoneEECountList={zoneEECountList}
                  zoneVSCountList={zoneVSCountList}
                  selectedVehicleView={selectedVehicleView}
                  selectedProjectIsZonal={selectedProjectDetails?.is_zonal}
                  centralizedEEList={centralizedEEList}
                  selectedEEComponentDetails={selectedEEComponentDetails}
                  selectedSingleVariantDetails={selectedSingleVariantDetails}
                />
              </>
            )
          ) : (
            // For non-suppliers: show regardless of is_zonal
            <>
              <VlcCarCard
                vsAndVCOptionsList={vsAndVCOptionsList}
                availableZones={availableZones}
                selectedComponent={selectedZone}
                setSelectedComponent={setSelectedZone}
                zoneEECountList={zoneEECountList}
                zoneVSCountList={zoneVSCountList}
                selectedVehicleView={selectedVehicleView}
                centralizedEEList={centralizedEEList}
                selectedEEComponentDetails={selectedEEComponentDetails}
                selectedSingleVariantDetails={selectedSingleVariantDetails}
              />
            </>
          )}
        </Box>

        {/* 🟦 Right Box (EE & SWM) */}
        <Box
          sx={{
            flex: 2,
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* <Outlet /> */}
          <Routes>
            <Route
              path="EESWM"
              element={
                <VlcMain
                  selectedSingleVariantDetails={selectedSingleVariantDetails}
                  setSelectedSingleVariantDetails={
                    setSelectedSingleVariantDetails
                  }
                  projectOptionsList={projectOptionsList}
                  variantOptionList={variantOptionList}
                  setProjectOptionsList={setProjectOptionsList}
                  selectedVariant={selectedVariant}
                  selectedProject={selectedProject}
                  setSelectedProject={setSelectedProject}
                  selectedVariantDetails={selectedVariant}
                  selectedProjectDetails={selectedProject}
                  setSelectedVehicleView={setSelectedVehicleView}
                  selectedVehicleView={selectedVehicleView}
                  selectedEEComponentDetails={selectedEEComponentDetails}
                  setSelectedEEComponentDetails={setSelectedEEComponentDetails}
                  selectedZone={selectedZone}
                  setSelectedZone={setSelectedZone}
                  selectedZoneDetails={selectedZoneDetails}
                  setSelectedZoneDetails={setSelectedZoneDetails}
                  getApiDataforFilter={getApiDataforFilter}
                  setGetApiDataforFilter={setGetApiDataforFilter}
                  filterData={filterData}
                  zoneEECountList={zoneEECountList}
                  setZoneEECountList={setZoneEECountList}
                  setProjectEECount={setProjectEECount}
                  getZoneEECountList={getZoneEECountList}
                />
              }
            />
            <Route
              path="vehicle-systems"
              element={
                <VlcVehicleSystemsIndex
                  selectedProjectDetails={selectedProjectDetails}
                  selectedSingleVariantDetails={selectedSingleVariantDetails}
                  selectedZoneDetails={selectedZoneDetails}
                  variantOptionList={variantOptionList}
                  vsAndVCOptionsList={vsAndVCOptionsList}
                  getZoneVSCountList={getZoneVSCountList}
                />
              }
            />
          </Routes>
        </Box>
      </Box>
    </Box>
  );
}
export default VlcIndex;
